/**
 * Notification Redirect Handler
 * Handles navigation based on notification type and related ID
 */

/**
 * Get redirect path based on notification type and related ID
 * @param {string} notificationType - Type of notification (e.g., "complaints", "orders", etc.)
 * @param {string} relatedId - Related record ID
 * @returns {string|null} - Redirect path or null if no handler exists
 */
export const getNotificationRedirectPath = (notificationType, relatedId) => {
  if (!notificationType || !relatedId) {
    return null;
  }

  const type = notificationType.toLowerCase();

  switch (type) {
    case 'complaints':
      return `/view-complaint?id=${relatedId}`;
    
    // Add more cases as needed for other modules
    // case 'orders':
    //   return `/view-order?id=${relatedId}`;
    // case 'invoices':
    //   return `/view-invoice?id=${relatedId}`;
    
    default:
      console.warn(`[NOTIFICATION REDIRECT] Unknown notification type: ${notificationType}`);
      return null;
  }
};

/**
 * Handle notification click - redirects and marks as read
 * @param {object} notification - Notification object
 * @param {function} navigate - React Router navigate function
 * @param {function} markAsReadCallback - Callback to mark notification as read
 * @returns {boolean} - True if redirect was handled, false otherwise
 */
export const handleNotificationClick = (notification, navigate, markAsReadCallback) => {
  // Get notification type and related ID
  const notificationType = notification.notification_type || notification.data?.notification_type;
  const relatedId = notification.related_id || notification.data?._id || notification.data?.id;

  if (!notificationType || !relatedId) {
    console.warn('[NOTIFICATION REDIRECT] Missing notification type or related ID:', notification);
    return false;
  }

  // Get redirect path
  const redirectPath = getNotificationRedirectPath(notificationType, relatedId);

  if (!redirectPath) {
    console.warn('[NOTIFICATION REDIRECT] No redirect path found for type:', notificationType);
    return false;
  }

  // Mark as read if not already read (silently, no success modal)
  if (!notification.read && markAsReadCallback) {
    markAsReadCallback(notification._id, false);
  }

  // Navigate to the page
  navigate(redirectPath);

  return true;
};

export default {
  getNotificationRedirectPath,
  handleNotificationClick
};

